<template>
  <div class="table">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th class="content">商品</th>
          <th class="spe">商品规格</th>
          <th class="num">商品数量</th>
          <th class="person">收货人</th>
          <th class="order-state">订单状态</th>
          <th class="operation">操作</th>
        </tr>
      </thead>
      <tbody style="width:100%; text-align:center; font-size:16px; height: 300px; line-height: 250px" v-if="list.length <= 0">暂无试用订单历史 <span  style="
                  color: #A52A2A;
                  cursor: pointer;
                  text-decoration: underline;
                " @click="()=>{ this.$router.push('/tryOut')}">去申请</span></tbody>
      <tbody v-else>
        <template v-for="(item,index) in list">
          <tr class="tbody-null"></tr>
          <tr class="tbody-head" :key="index">
            <span class="date">{{ item.create_time }}</span>
            <span class="orderhao">申请单号:{{ item.trial_number }}</span>
          </tr>
          <tr class="tbody-main" v-for="(i, v) in item.goods" :key="item[v]">
            <td class="content" style="margin-left: unset">
              <div class="right">
                <p class="text">{{ i.goods_name }}</p>
                <p class="number" @click="goxqs(i.goods_code)">{{ i.goods_code }}</p>
                <p class="english">{{ i.english }}</p>
              </div>
            </td>
            <td class="spe">
              <span>{{ i.sku }}</span>
            </td>
            <td class="num">
              <span>{{ i.num }}</span>
            </td>
            <td class="person">
              <span>{{ item.username }}</span>
            </td>
            <td class="order-state" :rowspan="item.goods.length">
              {{
                ["待审核", "已审核", "已发货", "已完成", "已取消"][item.status]
              }}
            </td>
            <td class="operation" :rowspan="item.goods.length">
              <button class="remove" @click="goxq(item.trial_number)">
                查看详情
              </button>
              <button v-if="item.status == 2" @click="gowl(item.trial_number)">查看物流</button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {

    };
  },
  methods: {
    goxq(order_number) {
      if(order_number){
         let routeUrl = this.$router.resolve({
          path: "/personalCenter/tryOrderCenter/detail",
          query: {
            order_number: order_number
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    goxqs(id) {
      this.$router.push({
        path: `/homepage/detail`,
        query: {
          id: id
        }
      });
    },
    gowl(order_number) {
      if(order_number){
        let routeUrl = this.$router.resolve({
          path: "/personalCenter/tryOrderCenter/detail",
          query: {
            order_number: order_number,
            flag:true
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>

<style lang="less" scoped>
table{
  border-collapse:collapse;
}
thead {
  width: 876px;
  height: 58px;
  background: #f5f5f5;
   tr {
    display: flex;
    line-height: 58px;
    font-size: 15px;
    color:#000
  }
}
tbody {
  .tbody-null{
    height:10px;
  }
    .tbody-head {
      height: 38px;
      background: #f5f5f5;
      border-top:none;
      line-height: 38px;
      .date {
        padding-left: 21px;
      }
      .orderhao {
        padding-left: 70px;
      }
    }
    .tbody-main {
      width: 876px;
      min-height: 80px;
      border: 1px solid #dddddd;
      border-top:none;
      background: #fff;
      display: flex;
      align-items: center;
      .pay-state:hover {
        width: 72px;
        color: #ffbb00;
        cursor: pointer;
        text-decoration: underline;
      }
      .colspan {
        display: flex;
      }
    }
}
.number {
  color: #a52a2a;
  cursor: pointer;
}
thead tr,
.tbody-main {
  text-align: center;
  .content {
    width: 350px;
    padding-left:20px;
    text-overflow: ellipsis;
    display: inline-block;
    text-align: left;
  }
  .num {
    width: 100px;
  }
  .spe {
    width: 100px;
  }
  .person {
    width: 100px;
  }

  .pay-state {
    width: 100px;
    cursor: pointer;
  }
  .pay-state {
    width: 100px;
  }
  .order-state {
    width: 100px;
  }
  .operation {
    width: 100px;
    display: flex;
    flex-direction: column;
    button {
      cursor: pointer;
      border: 0px;
      background: #fff;
      font-size: 12px;
      color: #003871;
    }
  }
}
</style>
